
export const remoteDavinciUrl = "davinci-onthego.tgle.mx";

export const isRemoteDavinci = ()=>{
    return window.location.hostname === remoteDavinciUrl ||
        process.env.REACT_APP_REMOTE_DAVINCI === "true";
};
